<template>
  <BModal
    v-model="isOpen"
    no-enforce-focus
    size="lg"
    centered
    hide-footer
    title="Edit invoice footer note"
  >
    <div class="row no-gutters">
      <AppWysiwyg
        :value="invoice.footer_note"
        @input="updateFooterNote($event)"
        class="col-12"
        label="Footer note"
        field="footer_note"
        :errors="errors"
      />
    </div>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="save">Save</button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import Errors from '../../utils/errors';
import AppWysiwyg from '../form/AppWysiwyg';

export default {
  data() {
    return {
      errors: new Errors(),
      footer_note: null,
    };
  },
  components: {
    AppWysiwyg,
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isFooterNoteModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isFooterNoteModalOpen', val);
      },
    },
    ...mapGetters({
      invoice: 'invoices/invoice',
    }),
  },
  methods: {
    updateFooterNote(note) {
      this.footer_note = note;
    },
    save() {
      if (this.footer_note !== null) {
        this.updateInvoiceProps({ footer_note: this.footer_note });
      }
      this.$store.commit('invoices/isFooterNoteModalOpen', false);
      this.$store.dispatch('invoices/updateInvoice');
    },
    updateInvoiceProps(props) {
      this.$store.dispatch('invoices/updateInvoiceProps', props);
    },
  },
};
</script>
